/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Link } from "react-router-dom";
import { theme } from "@nordcloud/gnui";
import { ColumnProps } from "~/components/Tables/types";
import { ROUTES } from "~/routing";

type Product = {
  id: string;
  name: string;
};

export const ProductCatalogListColumns: ColumnProps<Product>[] = [
  {
    Header: "Name",
    accessor: "name",
    width: "35%",
    Cell: ({ row }) => {
      return (
        <Link
          css={{ color: theme.color.text.text01 }}
          to={`${ROUTES.productCatalog.index}/${row.original.id}`}
        >
          {row.original?.name}
        </Link>
      );
    },
  },
];
